import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "thumbs-up, thumb, hand, yes, pro" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10.1056 2.55279C10.275 2.214 10.6212 2 11 2H11.6156C13.4567 2 14.8634 3.64303 14.5798 5.46216L14.1841 8H18.0631C20.4871 8 22.354 10.1387 22.0265 12.5405L21.3446 17.5405C21.0744 19.5224 19.3816 21 17.3813 21H4C2.89543 21 2 20.1046 2 19V12C2 10.8954 2.89543 10 4 10H6.38197L10.1056 2.55279ZM6 12H4V19H6V12ZM8 19H17.3813C18.3815 19 19.2279 18.2612 19.363 17.2702L20.0448 12.2702C20.2086 11.0694 19.2751 10 18.0631 10H13.0161C12.724 10 12.4465 9.87227 12.2565 9.65036C12.0665 9.42846 11.9831 9.13458 12.0281 8.84595L12.6037 5.15405C12.6981 4.54847 12.2306 4.00144 11.618 4L8 11.2361V19Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }